import { redirect } from "@tanstack/react-router";

type BeforeLoadArgs = {
  location: { search: unknown; hash?: string };
};

/**
 * Retired URL -> current URL, answered as a real HTTP 301 when the request is
 * server-rendered (crawlers, first visits) and as a replace-navigation in the
 * browser. Mirrors the old client-side <Redirect>: the visitor's query string
 * and hash are carried over; a hash in the target wins.
 */
export function permanentRedirect(to: string) {
  const [pathname, targetHash] = to.split("#");
  return ({ location }: BeforeLoadArgs) => {
    throw redirect({
      to: pathname as never,
      search: location.search as never,
      hash: targetHash || location.hash || undefined,
      replace: true,
      statusCode: 301,
    });
  };
}

/** Redirect to a URL the app router does not own (static file or another host). */
export function externalRedirect(href: string) {
  return () => {
    throw redirect({ href, statusCode: 301 });
  };
}
